/* eslint-disable max-len */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';

import { AiOutlineSearch, AiOutlineUnorderedList } from 'react-icons/ai';
import { PiSquaresFourFill } from 'react-icons/pi';
import ReactLoading from 'react-loading';
import { twMerge } from 'tailwind-merge';
import GridViewCards from '../GridViewCards';
import ListViewCards from '../ListViewCard';
import { CareersViewRendererProps, OpenJob } from '../../types';

interface OpenPositionsProps extends CareersViewRendererProps { }

export default function OpenPositions(props: OpenPositionsProps) {
  const { careers: jobs, loading } = props;
  const [showGridView, setShowGridView] = useState(true);

  const [filteredJobs, setFilteredJobs] = useState<OpenJob[]>([]);
  const [search, setSearch] = useState('');

  const fuzzySearchJobs = () => {
    const filtered: OpenJob[] = search !== '' ? jobs.filter((el: OpenJob) => (
      el.jobTitle.toLowerCase().includes(search.toLowerCase())
      || el.location.some((location: string) => location.toLowerCase().includes(search.toLowerCase()))
    )) : jobs;
    setFilteredJobs(filtered);
  };

  useEffect(() => {
    fuzzySearchJobs();
  }, [search, jobs]);

  return (
    <div className="mx-auto px-2 md:px-8 py-20 max-w-7xl">
      <h1 className="font-black text-4xl text-primary">Open Positions</h1>
      <div className="mx-auto max-w-3xl">
        <p className="mt-8 font-light">
          No matter what role you play, know that you will be contributing
          to cutting-edge technologies that will shape the future as we know it.
        </p>
        <p className="mt-8 font-light">
          Interested? Explore our job opportunities...
        </p>
      </div>

      {loading ? (
        <div className="flex justify-center items-center bg-white w-full h-[60]">
          <div className="text-slate-400 text-sm">
            Loading
          </div>
          <ReactLoading
            type="bubbles"
            color="#00A6CF"
            height={60}
            width={60}
          />
        </div>
      ) : (
        <>
          <div className="flex md:flex-row flex-col md:justify-between">
            <div className="flex items-center space-x-2 mt-5 lg:mt-20 border-b w-fit">
              <AiOutlineSearch className="w-6 h-6 text-neutral-300" />
              <input
                type="text"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Enter job title, location"
                className="border-none focus:outline-none focus:ring-0"
              />
            </div>
            <div className="flex gap-3 mt-5 lg:mt-20">
              <button
                type="button"
                className={twMerge(
                  'flex justify-between items-center gap-2 hover:border-[#00A6CF] px-5 py-3 border border-black/[0.8] rounded-full text-sm hover:text-[#00A6CF]',
                  showGridView && 'text-[#00A6CF] border-[#00A6CF]',
                )}
                onClick={() => setShowGridView(true)}
              >
                <PiSquaresFourFill />
                <span>Grid-View</span>
              </button>
              <button
                type="button"
                className={twMerge(
                  'flex justify-between items-center gap-2 hover:border-[#00A6CF] px-5 py-3 border border-black/[0.5] rounded-full text-sm hover:text-[#00A6CF]',
                  !showGridView && 'text-[#00A6CF] border-[#00A6CF]',
                )}
                onClick={() => setShowGridView(false)}
              >
                <AiOutlineUnorderedList />
                <span>List-View</span>
              </button>
            </div>
          </div>
          {
            showGridView ? (
              <GridViewCards
                jobs={filteredJobs.reverse()}
                search={search}
              />
            ) : (
              <ListViewCards
                jobs={filteredJobs.reverse()}
                search={search}
              />
            )
          }
        </>
      )}
    </div>
  );
}
